import React from "react";
import { User } from "../../modules/authentication/domain";
import { getAvatarColors, getInitials } from "./colorUtils";

type Props = {
  user: User;
  size?: number;
};

export const InitialsAvatar: React.FC<Props> = ({ user, size = 40 }) => {
  const initials = getInitials(user.name);
  const { background } = getAvatarColors(user.email.value);

  return (
    <div
      style={{
        background,
        width: size,
        height: size,
        borderRadius: "50%",
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "bold",
        fontSize: size * 0.4,
      }}
    >
      {initials}
    </div>
  );
};
